import { DeliveryNote, Expense } from "@finway-group/shared/lib/models"
import { getUniqueElements } from "@finway-group/shared/lib/utils/helpers"
import { useEffect, useState } from "react"
import { PurchaseOrderReference } from "~Shared/models/purchaseOrderReference"
import { getLinkedPurchaseOrders } from "~Shared/utils/expense.utils"

const getLinkedPurchaseOrdersFromExpense = (expense: Expense) => {
    const linkedPurchaseOrders = getLinkedPurchaseOrders(expense).map<PurchaseOrderReference>((link) => ({
        ...link,
        alreadyLinked: true,
    }))
    const uniqueLinkedPurchaseOrders = getUniqueElements(linkedPurchaseOrders, "_id")
    return uniqueLinkedPurchaseOrders
}

export const usePurchaseOrdersSelectedForExpense = ({ purchaseOrder, isNew, expense }: { purchaseOrder?: PurchaseOrderReference; isNew: boolean; expense?: Expense }) => {
    const [selectedPurchaseOrders, setSelectedPurchaseOrders] = useState<Array<PurchaseOrderReference>>([])

    useEffect(() => {
        if (!isNew && expense && expense?.splits?.length > 0) {
            setSelectedPurchaseOrders(getLinkedPurchaseOrdersFromExpense(expense))
        } else {
            setSelectedPurchaseOrders(purchaseOrder ? [purchaseOrder] : [])
        }
    }, [purchaseOrder, isNew, expense?.id])

    return {
        selectedPurchaseOrders,
        setSelectedPurchaseOrders,
        preSelectedPurchaseOrder: purchaseOrder,
    }
}

const getLinkedPurchaseOrdersFromDeliveryNote = (deliveryNote: Pick<DeliveryNote, "_id" | "lineItems">) => {
    const linkedPurchaseOrders = deliveryNote.lineItems
        .filter((lineItem) => lineItem.purchaseOrderLink)
        .map<PurchaseOrderReference>((lineItem) => ({
            _id: lineItem.purchaseOrderLink!._id,
            purchaseOrderNumber: lineItem.purchaseOrderLink!.purchaseOrderNumber,
            alreadyLinked: true,
        }))
    const uniqueLinkedPurchaseOrders = getUniqueElements(linkedPurchaseOrders, "_id")
    return uniqueLinkedPurchaseOrders
}

export const usePurchaseOrdersSelectedForDeliveryNote = ({
    purchaseOrder,
    isNew,
    deliveryNote,
}: {
    purchaseOrder?: PurchaseOrderReference
    isNew: boolean
    deliveryNote?: Pick<DeliveryNote, "_id" | "lineItems">
}) => {
    const [selectedPurchaseOrders, setSelectedPurchaseOrders] = useState<Array<PurchaseOrderReference>>([])

    useEffect(() => {
        if (!isNew && deliveryNote && deliveryNote?.lineItems?.length > 0) {
            setSelectedPurchaseOrders(getLinkedPurchaseOrdersFromDeliveryNote(deliveryNote))
        } else {
            setSelectedPurchaseOrders(purchaseOrder ? [purchaseOrder] : [])
        }
    }, [purchaseOrder, isNew, deliveryNote?._id])

    return {
        selectedPurchaseOrders,
        setSelectedPurchaseOrders,
        preSelectedPurchaseOrder: purchaseOrder,
    }
}
